import React, { Component } from "react";
import countryList from "react-select-country-list";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import DataTable from "../../../components/Tables/DataTable";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import {
  getAvailableTwilioNumbers,
  buyTwilioNumber,
} from "../../../config/agent_forms_api_calls";
import Select from "react-select";
import Tooltip from "@material-ui/core/Tooltip";

const auth = new HelperClass();

class TwilioBuyNumberBuy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      allNumbers: [],
      tableLoader: false,
      country: "US",
      capabilities: {
        voice: false,
        sms: false,
        mms: false,
        fax: false,
      },
      searchType: "Number",
      searchValue: "",
      matchType: "First part of number",
      showAdvancedSearch: false,
      errorMessage: "",
      successMessage: "",
      initialLoad: true,
    };

    this.columns = [
      {
        name: "Number",
        options: {
          customBodyRender: (value) => {
            const [number, location] = value.split("||");
            return (
              <div>
                <div style={{ fontWeight: "600", fontSize: "15px" }}>
                  {number}
                </div>
                <div style={{ fontSize: "13px", color: "#8094ae" }}>
                  {location}
                </div>
              </div>
            );
          },
        },
      },
      {
        name: "Type",
        options: {
          customBodyRender: (value) => (
            <span style={{ fontSize: "14px", color: "#526484" }}>{value}</span>
          ),
        },
      },
      {
        name: "Capabilities",
        label: "Capabilities",
        options: {
          customBodyRender: (value) => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "20px",
              }}
            >
              {/* Voice */}
              <Tooltip
                title="Voice"
                placement="top"
                enterDelay={0}
                leaveDelay={0}
                arrow
              >
                <em
                  className={`icon ni ni-call`}
                  style={{
                    fontSize: "20px",
                    color: value.voice ? "inherit" : "#d6d6d6",
                    cursor: "pointer",
                  }}
                ></em>
              </Tooltip>

              {/* SMS */}
              <Tooltip
                title="SMS"
                placement="top"
                enterDelay={0}
                leaveDelay={0}
                arrow
              >
                <em
                  className={`icon ni ni-chat-circle`}
                  style={{
                    fontSize: "20px",
                    color: value.SMS ? "inherit" : "#d6d6d6",
                    cursor: "pointer",
                  }}
                ></em>
              </Tooltip>

              {/* MMS */}
              <Tooltip
                title="MMS"
                placement="top"
                enterDelay={0}
                leaveDelay={0}
                arrow
              >
                <em
                  className={`icon ni ni-img`}
                  style={{
                    fontSize: "20px",
                    color: value.MMS ? "inherit" : "#d6d6d6",
                    cursor: "pointer",
                  }}
                ></em>
              </Tooltip>

              {/* Fax */}
              <Tooltip
                title="Fax"
                placement="top"
                enterDelay={0}
                leaveDelay={0}
                arrow
              >
                <em
                  className={`icon ni ni-inbox-in`}
                  style={{
                    fontSize: "20px",
                    color: value.fax ? "inherit" : "#d6d6d6",
                    cursor: "pointer",
                  }}
                ></em>
              </Tooltip>
            </div>
          ),
        },
      },
      {
        name: "Address Requirement",
        options: {
          customBodyRender: (value) => (
            <span
              style={{
                fontSize: "14px",
                color: "#526484",
                textTransform: "capitalize",
              }}
            >
              {value}
            </span>
          ),
        },
      },
      {
        name: "Monthly fee",
        options: {
          customBodyRender: (value) => (
            <span style={{ fontSize: "14px", fontWeight: "600" }}>
              ${value}
            </span>
          ),
        },
      },
      {
        name: "Action",
        options: {
          customBodyRender: (value, tableMeta) => {
            const phone = tableMeta.rowData[0].split("||")[0];
            return (
              <button
                className="btn btn-sm btn-outline-primary"
                style={{
                  padding: "5px 15px",
                  fontSize: "13px",
                  fontWeight: "500",
                }}
                onClick={() => this.buyNumber(phone)}
              >
                Buy
              </button>
            );
          },
        },
      },
    ];

    this.countryOptions = countryList()
      .getData()
      .filter(
        (country) => country.label !== "United States Minor Outlying Islands"
      );

    this.searchTypeOptions = [
      { value: "Number", label: "Number" },
      { value: "Locality", label: "Locality" },
    ];

    this.matchTypeOptions = [
      { value: "First part of number", label: "First part of number" },
      { value: "Contains", label: "Contains" },
      { value: "Ends with", label: "Ends with" },
    ];
  }

  componentDidMount() {
    this.fetchAvailableNumbers(true);
  }

  handleCapabilityChange = (key) => {
    this.setState((prev) => ({
      capabilities: { ...prev.capabilities, [key]: !prev.capabilities[key] },
    }));
  };

  handleChangeCountry = (selectedOption) => {
    this.setState(
      { country: selectedOption.value },
      () => this.fetchAvailableNumbers(true) // fetch immediately
    );
  };

  resetFilters = () => {
    this.setState({
      country: "US",
      capabilities: {
        voice: false,
        sms: false,
        mms: false,
        fax: false,
      },
      searchType: "Number",
      searchValue: "",
      matchType: "First part of number",
    });
  };

  fetchAvailableNumbers = async (initial = false) => {
    this.setState({ tableLoader: true, errorMessage: "", successMessage: "" });

    try {
      const {
        country,
        capabilities,
        searchValue,
        searchType,
        matchType,
        limit = 10,
      } = this.state;

      let searchQuery = "";
      let searchMode = ""; // "area" | "contains" | "locality"

      // 🧩 Determine mode
      if (searchValue.trim() !== "") {
        if (searchType === "Number") {
          const digits = searchValue.replace(/\D/g, "");
          if (digits === "") {
            this.setState({
              tableLoader: false,
              errorMessage:
                "Please enter numeric digits only for Number search.",
            });
            setTimeout(() => this.setState({ errorMessage: "" }), 5000);
            return;
          }

          if (matchType === "First part of number") {
            let searchDigits = digits;
            let shouldUseAreaCode = false;

            // For US/Canada numbers starting with "1"
            if (
              country === "US" &&
              digits.startsWith("1") &&
              digits.length > 1
            ) {
              const afterCountryCode = digits.substring(1);

              // Only use AreaCode if we have exactly 3 digits after country code
              if (afterCountryCode.length === 3 && digits.length === 4) {
                searchMode = "area";
                searchQuery = afterCountryCode; // e.g., "315" from "1315"
                shouldUseAreaCode = true;
              }
            } else if (digits.length === 3) {
              // Just 3 digits without country code - valid area code
              searchMode = "area";
              searchQuery = digits;
              shouldUseAreaCode = true;
            }

            // For all other cases, use Contains
            if (!shouldUseAreaCode) {
              searchMode = "contains";
              searchQuery = digits;
            }
          } else if (matchType === "Contains") {
            searchMode = "contains";
            searchQuery = digits;
          } else if (matchType === "Ends with") {
            searchMode = "contains";
            searchQuery = digits;
          }
        } else if (searchType === "Locality") {
          const isNumeric = /^[0-9]+$/.test(searchValue.trim());
          if (isNumeric) {
            this.setState({
              tableLoader: false,
              errorMessage:
                "Please enter a valid city or locality name, not digits.",
            });
            setTimeout(() => this.setState({ errorMessage: "" }), 5000);
            return;
          }
          searchQuery = searchValue.trim();
          searchMode = "locality";
        }
      }

      const activeCaps = Object.keys(capabilities).filter(
        (k) => capabilities[k]
      );

      const response = await getAvailableTwilioNumbers(
        auth.getAccount(),
        auth.getToken(),
        process.env.REACT_APP_TWILIO_SID,
        process.env.REACT_APP_TWILIO_TOKEN,
        country,
        searchQuery,
        activeCaps,
        searchMode
      );

      // ✅ Filter EndsWith locally (since Twilio can't do it)
      let numbers = response.data || [];
      if (
        matchType === "Ends with" &&
        searchType === "Number" &&
        searchValue.trim() !== ""
      ) {
        const digits = searchValue.replace(/\D/g, "");
        numbers = numbers.filter((num) => num.phone_number.endsWith(digits));
      }

      if (response.status === 200 && numbers.length > 0) {
        const formatted = numbers.slice(0, limit).map((num) => [
          `${num.phone_number}||${num.locality || "Unknown"}, ${
            num.region || ""
          } ${num.iso_country}`,
          "Local",
          {
            voice: num.capabilities.voice || false,
            SMS: num.capabilities.SMS || false,
            MMS: num.capabilities.MMS || false,
          },
          num.address_requirements || "none",
          "1.15",
          null,
        ]);

        this.setState({
          tableData: formatted,
          tableLoader: false,
          initialLoad: false,
        });
      } else {
        this.setState({
          tableLoader: false,
          tableData: [],
          errorMessage: "No numbers found for selected filters.",
        });
        setTimeout(() => this.setState({ errorMessage: "" }), 5000);
      }
    } catch (err) {
      console.error("Fetch Error:", err);
      this.setState({
        tableLoader: false,
        tableData: [],
        errorMessage: "Unable to fetch numbers from Twilio.",
      });
      setTimeout(() => this.setState({ errorMessage: "" }), 5000);
    }
  };

  buyNumber = async (number) => {
    try {
      this.setState({
        tableLoader: true,
        errorMessage: "",
        successMessage: "",
      });

      const response = await buyTwilioNumber(
        auth.getAccount(),
        auth.getToken(),
        process.env.REACT_APP_TWILIO_SID,
        process.env.REACT_APP_TWILIO_TOKEN,
        this.state.country,
        number,
        `Purchased ${number}`
      );

      if (response.status === 200) {
        this.setState({
          successMessage: `✅ Number ${number} purchased successfully.`,
          tableLoader: false,
        });
        setTimeout(() => this.setState({ successMessage: "" }), 5000);
      } else {
        this.setState({
          errorMessage:
            response.message || `Failed to purchase number ${number}.`,
          tableLoader: false,
        });
        setTimeout(() => this.setState({ errorMessage: "" }), 5000);
      }
    } catch (err) {
      console.error("Buy Error:", err);
      this.setState({
        errorMessage: "Unable to complete purchase. Please try again.",
        tableLoader: false,
      });
      setTimeout(() => this.setState({ errorMessage: "" }), 5000);
    }
  };

  render() {
    const {
      tableData,
      capabilities,
      country,
      searchValue,
      searchType,
      matchType,
      showAdvancedSearch,
      tableLoader: loading,
    } = this.state;

    const selectedCountry = this.countryOptions.find(
      (c) => c.value === country
    );

    return (
      <div className="nk-content">
        <div className="container-fluid">
          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* ===== Header ===== */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitle name="Buy a Number" icon="icon ni ni-call" />
                    </h3>
                  </div>
                  {/* <div className="nk-block-head-content">
                    <button className="btn btn-outline-light">
                      Can't find a number?
                    </button>
                  </div> */}
                </div>
              </div>

              {/* ===== Filters Card ===== */}
              <div className="card card-bordered mb-4">
                <div className="card-inner">
                  {this.state.errorMessage !== "" ? (
                    <div className="example-alert mb-2">
                      <div className="alert alert-pro alert-danger">
                        <div className="alert-text">
                          <h4>Error</h4>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: this.state.errorMessage,
                            }}
                          ></p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {/* Row 1: Country and Capabilities */}
                  <div className="row g-3 mb-3">
                    <div className="col-md-3">
                      <label
                        className="form-label fw-bold"
                        style={{ fontSize: "13px", marginBottom: "8px" }}
                      >
                        Country
                      </label>
                      <Select
                        options={this.countryOptions}
                        value={selectedCountry}
                        onChange={this.handleChangeCountry}
                        placeholder="Select a country"
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: "44px",
                            borderColor: "#dbdfea",
                          }),
                        }}
                      />
                    </div>

                    <div className="col-md-9">
                      <label
                        className="form-label fw-bold"
                        style={{ fontSize: "13px", marginBottom: "8px" }}
                      >
                        Capabilities
                      </label>
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          flexWrap: "wrap",
                        }}
                      >
                        {["voice", "sms", "mms", "fax"].map((cap) => (
                          <label
                            key={cap}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px",
                              padding: "8px 16px",
                              borderRadius: "4px",
                              border: "1px solid #dbdfea",
                              backgroundColor: capabilities[cap]
                                ? "#0052cc"
                                : "#fff",
                              color: capabilities[cap] ? "#fff" : "#526484",
                              cursor: "pointer",
                              fontSize: "14px",
                              fontWeight: "500",
                              transition: "all 0.2s",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={capabilities[cap]}
                              onChange={() => this.handleCapabilityChange(cap)}
                              style={{
                                width: "16px",
                                height: "16px",
                                cursor: "pointer",
                              }}
                            />
                            {cap.charAt(0).toUpperCase() + cap.slice(1)}
                          </label>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Row 2: Search Criteria */}
                  <div className="row g-3 align-items-end">
                    <div className="col-lg-2 col-md-6">
                      <label
                        className="form-label fw-bold"
                        style={{ fontSize: "13px", marginBottom: "8px" }}
                      >
                        Search criteria
                      </label>
                      <Select
                        options={this.searchTypeOptions}
                        value={this.searchTypeOptions.find(
                          (opt) => opt.value === searchType
                        )}
                        onChange={(opt) =>
                          this.setState({ searchType: opt.value })
                        }
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: "44px",
                            borderColor: "#dbdfea",
                          }),
                        }}
                      />
                    </div>

                    <div className="col-lg-4 col-md-6">
                      <label
                        className="form-label"
                        style={{
                          fontSize: "13px",
                          marginBottom: "8px",
                          visibility: "hidden",
                        }}
                      >
                        Search
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={
                          this.state.searchType === "Number"
                            ? "Search by digits"
                            : "Search by city or region"
                        }
                        value={searchValue}
                        onChange={(e) =>
                          this.setState({ searchValue: e.target.value })
                        }
                        style={{
                          height: "44px",
                          borderColor: "#dbdfea",
                        }}
                      />
                    </div>

                    <div className="col-lg-3 col-md-6">
                      <label
                        className="form-label fw-bold"
                        style={{ fontSize: "13px", marginBottom: "8px" }}
                      >
                        Match to
                      </label>
                      <Select
                        options={this.matchTypeOptions}
                        value={this.matchTypeOptions.find(
                          (opt) => opt.value === matchType
                        )}
                        onChange={(opt) =>
                          this.setState({ matchType: opt.value })
                        }
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: "44px",
                            borderColor: "#dbdfea",
                          }),
                        }}
                      />
                    </div>

                    <div className="col-lg-3 col-md-6">
                      <div style={{ display: "flex", gap: "10px" }}>
                        <a
                          className="btn btn-primary d-flex align-items-center justify-content-center"
                          onClick={() => this.fetchAvailableNumbers(true)}
                          style={{ height: "44px", flex: 1, color: "white" }}
                        >
                          <i className="icon ni ni-search mr-1"></i>
                          Search
                        </a>

                        <a
                          className="btn btn-secondary d-flex align-items-center justify-content-center"
                          onClick={() => {
                            this.resetFilters();
                            this.fetchAvailableNumbers(false);
                          }}
                          style={{ height: "44px", flex: 1, color: "white" }}
                        >
                          <i className="icon ni ni-reload mr-1"></i>
                          Reset
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* Help Text */}
                  <div className="row mt-2">
                    <div className="col-md-12">
                      <small style={{ color: "#8094ae", fontSize: "12px" }}>
                        Search by area code, prefix, or characters you want in
                        your phone number.
                      </small>
                    </div>
                  </div>

                  {/* Advanced Search Toggle */}
                  {/* <div className="row mt-3">
                    <div className="col-md-12">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.setState({
                            showAdvancedSearch: !showAdvancedSearch,
                          });
                        }}
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#0052cc",
                          textDecoration: "none",
                        }}
                      >
                        <em
                          className={`icon ni ni-chevron-${
                            showAdvancedSearch ? "up" : "down"
                          }`}
                          style={{ marginRight: "5px" }}
                        ></em>
                        Advanced Search
                      </a>
                    </div>
                  </div> */}

                  {/* Advanced Search Content */}
                  {showAdvancedSearch && (
                    <div
                      className="row mt-3 pt-3"
                      style={{ borderTop: "1px solid #dbdfea" }}
                    >
                      <div className="col-md-12">
                        <p style={{ fontSize: "13px", color: "#526484" }}>
                          Advanced search options will appear here (region
                          filters, etc.)
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* ===== Table ===== */}
              <div className="nk-block">
                {loading ? (
                  tableLoader()
                ) : tableData.length > 0 ? (
                  <div className="card card-bordered">
                    <DataTable
                      columns={this.columns}
                      tableData={tableData}
                      title=""
                      options={{
                        selectableRows: "none",
                        elevation: 0,
                      }}
                    />
                  </div>
                ) : (
                  <div className="card card-bordered">
                    <div className="card-inner">
                      <div
                        className="alert alert-info text-center"
                        style={{
                          margin: "40px 0",
                          fontSize: "14px",
                        }}
                      >
                        No numbers found for selected filters. Try adjusting
                        your search criteria.
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TwilioBuyNumberBuy;
